/*eslint no-undef: 0*/

function createMoreMenu(menu, width) {
  if($(window).width() > width) { //get body width without(!) scrollbar
    var w = 0;
    var mw = $(menu).parent().width() - 70; //70 = width of 'more' item
    var menuhtml = '';
    $(menu).children().each(function() {
      w += $(this).outerWidth(true);
      if (mw < w && !$(this).hasClass('more')) {
        menuhtml += $('<div>').append($(this).clone()).html();
        $(this).remove();
      }
    });
    if(menuhtml) {
      $(menu + " .dropdown.more>.collapse>ul").html('');
      $(menu + " .dropdown.more>.collapse>ul").append(menuhtml);
      $(menu + " .dropdown.more").removeClass('d-none');
    }
  }
}

function initMoreMenu() {
  $('header ul.more').each(function() {
    var menu = '#' + $(this).attr('id');
    var width = $(this).data('breakpoint') || 1025;
    var originalMenu = $(menu).clone();
    createMoreMenu(menu, width); $(menu).removeClass('vh'); $(originalMenu).removeClass('vh');
    $(window).on("resize ready load", function() { $(menu).replaceWith(originalMenu.clone()); createMoreMenu(menu, width); });
  });
}

export default initMoreMenu



// WEBPACK FOOTER //
// ./scripts/util/moreMenu.js